interface Props {
  when: boolean;
  children: React.ReactNode;

  fallback?: React.ReactNode;
}

const Show = (props: Props) => {
  const { when, children, fallback = null } = props;

  return <>{when ? children : fallback}</>;
};

export default Show;
